import { useRouter } from "next/router";
import Image from "next/future/image";
import Link from "next/link";
import React from "react";
import { FormattedMessage } from "react-intl";
import dynamic from "next/dynamic";
import styles from "./CommonQuestions.module.scss";
import { buildApiUrl } from "src/helpers/imageHelpers";
import BlueHoleIcon from "../../../../public/logo.png";
import { Container, Row,Col } from "react-bootstrap";

const AccordionComponent = dynamic(
  () =>
    import("src/components/AboutPage/AccordionComponent/AccordionComponent"),
);
import secondBg from "../../../assets/images/second-bg.png";

const CommonQuestions = ({
  commonQuestionsBackgroundImage,
  filteredQuestions,
}) => {
  const { locale } = useRouter();
  const isRtl = locale === "ar";
  const dir = isRtl ? "rtl" : "ltr";

  return (
    <section
      className={styles.questions}
      style={{ backgroundImage: `url(${secondBg.src})` }}
      dir={dir}
    >
      <Container>
        <h2 className={styles.customHead}>
          <FormattedMessage id="popular-questions" />
        </h2>

        <div className={styles["common-questions"]}>
          <Row className="gy-4">
            {/* <Col lg={6} xs={12}>
              <div
                className={styles["background-image"]}
                style={{
                  backgroundImage: commonQuestionsBackgroundImage
                    ? `url(${buildApiUrl(commonQuestionsBackgroundImage)})`
                    : "",
                }}
              >
                <div className={styles["overlay-text"]}>
                  <h2 className={styles["primary-text"]}>
                    <FormattedMessage id="have-question" />
                  </h2>
                  <p className={styles["secondary-text"]}>
                    <FormattedMessage id="have-question-desc" />
                  </p>
                  <Link href="/contactus" passHref>
                    <a className={styles["cta-button-red"]}>
                      <div className={styles["icon-circle"]}>
                        <svg
                          style={{ transform: isRtl ? "none" : "scaleX(-1)" }}
                          width="18"
                          height="18"
                          viewBox="0 0 18 18"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.53577 3.53556L14.1424 14.1422"
                            stroke="black"
                            strokeWidth={1.5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                          <path
                            d="M3.53553 10.6066L3.53553 3.53553L10.6066 3.53553"
                            stroke="black"
                            strokeWidth={1.5}
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>
                      <FormattedMessage id="contact-us" />
                    </a>
                  </Link>
                </div>
              </div>
            </Col> */}
            <Col  xs={12}>
              <div className={styles.accordion}>
                <AccordionComponent data={filteredQuestions} />
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default CommonQuestions;
